/* eslint-disable import/no-named-as-default-member */
import {
  capitalizeFirstLetter,
  requestTranslationFiles,
} from "@caprikorn/dynamo-utils";
import i18n from "i18next";
import languageDetector from "i18next-browser-languagedetector";
import backend, { type HttpBackendOptions } from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import { LANGUAGES, LS_KEYS } from "@core/core.constants";

const initI18n = (useBackend = true) => {
  i18n.use(initReactI18next).use(languageDetector);

  if (useBackend) {
    i18n.use(backend);
  }

  const i18nPromise = i18n.init<HttpBackendOptions>({
    detection: {
      lookupLocalStorage: LS_KEYS.LANGUAGE,
      order: ["localStorage"], // TODO: remove this line when we are ready to show english
    },
    supportedLngs: LANGUAGES,
    fallbackLng: "fr",
    load: "languageOnly",
    ns: ["common", "main"],
    returnNull: false,
    interpolation: { escapeValue: false },
    backend: {
      loadPath: `${
        import.meta.env.VITE_APP_FRONT_URL_PREFIX
      }/{{tenant}}/i18n/{{lng}}/{{ns}}.json?v=${__APP_VERSION__}`,
      request: requestTranslationFiles,
    },
  });

  i18n.on("languageChanged", (lang) => {
    document.documentElement.lang = lang;
  });

  i18n.services.formatter?.add("extendNumberSpace", (val: string) =>
    val.replace(/\u202F/g, "\u00A0"),
  );

  i18n.services.formatter?.add("hideNumberIfNaN", (val: string) =>
    val.replace("NaN", ""),
  );

  i18n.services.formatter?.add("hideDateIfNull", (val: string) => {
    if (val === i18n.services.formatter?.format(new Date(0), "datetime")) {
      return "";
    }
    return val;
  });

  i18n.services.formatter?.add("lowercase", (value: string) =>
    value.toLowerCase(),
  );
  i18n.services.formatter?.add("capitalizeFirstLetter", (value: string) =>
    capitalizeFirstLetter(value),
  );
  return i18nPromise;
};

/* @public knipignore */
export { i18n, initI18n };
